import { Vue, Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import BreakdownsModalBasicForm from '@/modules/configurationModule/detail/accounting/non-billable/breakdowns/components/breakdowns-modal-basic-form/breakdowns-modal-basic-form.vue'
import ConfigurationSidepanel from '@/modules/configurationModule/detail/ConfigurationSidepanel.vue'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        GridDisplayOptions,
        BreakdownsModalBasicForm,
        ConfigurationSidepanel
    }
})
export default class BreakdownsGrid extends Vue {
    @Ref() readonly breakdownsModalBasicForm!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any
    private showSidepanel !: boolean
    private sidepanelTitle !: string
    private selectedUnitRates !: Array<object>

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.breakdown', 1),
                colId: 'breakdown',
                field: 'breakdown',
                minWidth: 150,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.description'),
                colId: 'description',
                field: 'description',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.unit', 1),
                colId: 'unit',
                field: 'unit',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.entityType'),
                colId: 'entityType',
                field: 'entityType',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.asignTo'),
                colId: 'asignTo',
                field: 'asignTo',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.doneSample'),
                colId: 'doneSample',
                field: 'doneSample',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.doneSubportion'),
                colId: 'doneSubportion',
                field: 'doneSubportion',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('configuration.grid.active'),
                colId: 'active',
                field: 'active',
                minWidth: 80,
                suppressSizeToFit: true
            }
        ]
        this.rowData = [
            {
                breakdown: 'Desglose 1',
                description: 'Descripción',
                unit: 'UCL',
                active: true
            },
            {
                breakdown: 'Desglose 2',
                description: 'Descripción',
                unit: 'URV',
                active: true
            },
            {
                breakdown: 'Desglose 3',
                description: 'Descripción',
                unit: 'URV',
                active: true
            }
        ]
        this.gridApi = null
        this.showSidepanel = false
        this.sidepanelTitle = ''
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            },
            onRowClicked: params => {
                this.onRowClickedSidepanel()
                this.sidepanelTitle = params?.node.data.unit
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    onRowClickedSidepanel() {
        this.showSidepanel = true
    }

    showBreakdownModalBasicForm(title: string) {
        this.actionTitle = title
        this.breakdownsModalBasicForm.show()
    }

    // TODO: Mejorar esto en Front
    async deleteBreakdown() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
